import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: "How soon will I get my car removed?",
    answer: "We will proceed with car removal as soon as you accept our offer. Our tow truck driver will be with you at your scheduled time. To get your car removed within 24 hours, fill the online quote form now."
  },
  {
    question: "How to get quick cash for cars in Adelaide?",
    answer: "We offer fast cash for cars Adelaide wide. If you have decided to sell your vehicle for good cash, fill our online quote form or give us a call to provide details of your car. We will get back to you with an offer. As soon as you accept the offer, our tow team will ask you to sign the paperwork, give you cash and remove the car."
  },
  {
    question: "How do you decide on the quote for my car?",
    answer: "We strive hard to get you an accurate quote for your car and offer market-competitive prices. The offer may be affected by features and factors related to your cars, like their condition, age, mileage, model, and year. Moreover, your local market rate also decides your car's value."
  },
  {
    question: "Do you accept damaged or accident cars?",
    answer: "Yes, we accept all kinds of cars in any condition. If your vehicle has been in an accident, no worries. You can sell it to us for the highest cash and be on your way to buying your next dream car."
  },
  {
    question: "Is it safe to sell my unwanted car for cash?",
    answer: "Absolutely! It is totally safe to sell your car for cash with us. We have been operating in the Adelaide area for a long time, so you can trust us with the car selling process. If you still have any concerns, our team is available 24/7 to answer your queries."
  },
  {
    question: "Do you buy cars with administrative holds?",
    answer: "Yes, we guarantee the purchase, pickup, and immediate cash payment with maximum professionalism and transparency in handling all documentation, in a timely manner."
  },
  {
    question: "What types of vehicles do you buy?",
    answer: "We buy all types of vehicles including cars, trucks, vans, SUVs, 4x4s, and commercial vehicles. Whether your vehicle is damaged, old, not running, or in perfect condition, we'll make you a fair offer."
  }
];

export const Faq: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(/img/overlay2.png)',
          opacity: 0.1
        }}
      />

      <div className="container relative z-10 px-4 mx-auto">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          {/* Left Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <img
              src="/img/faq.jpg"
              alt="FAQ"
              className="object-cover w-full rounded-lg shadow-xl"
            />
            {/* Contact Overlay */}
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white bg-gradient-to-t from-black/80">
              <p className="text-2xl font-bold mb-2">Need Help?</p>
              <p className="mb-4">Our team is here to assist you 24/7</p>
              <a 
                href="tel:0431463481"
                className="inline-flex items-center px-6 py-3 bg-[#fdc751] text-gray-900 rounded-lg font-semibold hover:bg-[#fdc751]/90 transition"
              >
                Call Us Now
              </a>
            </div>
          </motion.div>

          {/* Right Column - FAQs */}
          <div className="space-y-6">
            <div className="mb-8">
              <h2 className="mb-4 text-3xl font-bold">Frequently Asked Questions</h2>
              <p className="text-gray-600">
                Find answers to common questions about our car buying service
              </p>
            </div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="overflow-hidden bg-white rounded-lg shadow-md"
                >
                  <button
                    onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                    className="flex items-center justify-between w-full p-4 text-left hover:bg-gray-50"
                  >
                    <span className="font-medium">{faq.question}</span>
                    <ChevronDown
                      className={`w-5 h-5 transition-transform ${
                        activeIndex === index ? 'transform rotate-180 text-[#fdc751]' : ''
                      }`}
                    />
                  </button>
                  <AnimatePresence>
                    {activeIndex === index && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="px-4 pb-4"
                      >
                        <p className="text-gray-600">{faq.answer}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


